import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  weeklychallenges: { nuevos: [], pendientes: [] },
  weeklychallenge: {}
}

const mutations = {  
  SET_WEEKLYCHALLENGES (state, payload) {
    state.weeklychallenges = payload
  },
  SET_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallenge = payload
  },
  ADD_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallenges.nuevos.push(payload)
  },
  DELETE_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallenges.nuevos = state.weeklychallenges.nuevos.filter(element => {
      return element._id != payload
    })
  },
  CLOSE_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallenges.pendientes = state.weeklychallenges.pendientes.filter(element => {
      return element._id != payload
    })
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  weeklyChallengesList: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenge`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWcByIdPlan: (context, data) => {
    const { id, user } = data
    return Vue.http.get(`${env.API}/api/weekly-challenge/by-plan/${id}/${user}`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createWC: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge`, data)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWCById: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenge/${id}`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGE', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  addCommentToWeeklyChallenges: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge/comment`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsFromWeeklyChallenges: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenges/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  close: (context, id) => {
    return Vue.http.delete(`${env.API}/api/weekly-challenge/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deleteWeeklyChallenges: (context, id) => {
    return Vue.http.delete(`${env.API}/api/weekly-challenge/remove/${id}`)    
      .then((response) => {      
        context.commit('DELETE_WEEKLYCHALLENGE', response.body.commitment)       
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closeWeeklyChallenge: (context, data) => {
    const { id, accomplished, planid } = data
    return Vue.http.put(`${env.API}/api/weekly-challenge/close/${id}`, { accomplished, planid })
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateBWeeklyChallenge: (context, data) => {
    return Vue.http.put(`${env.API}/api/weekly-challenge/update/batch/wc`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWcByUser: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge/by-user-perWeek`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getWeeklyChallenges: (state) => state.weeklychallenges,
  getWeeklyChallenge: (state) => state.weeklychallenge
}

export const weeklychallenge = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/weekly_challenge.js